import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTag } from "@fortawesome/pro-solid-svg-icons";

const PriceAccessNote = () => (
    <div className="flex items-center gap-3 w-full rounded-lg border-2 border-primary/30 bg-primary/5 px-4 py-3">
        <div className="flex items-center justify-center w-9 h-9 rounded-full bg-primary text-white flex-shrink-0">
            <FontAwesomeIcon icon={faTag} />
        </div>
        <div className="flex flex-col">
            <span className="text-sm font-semibold text-gray-700">
                Your price is just one step away
            </span>
            <span className="text-xs text-gray-600">
                Enter your details below for instant access to your price.
            </span>
        </div>
    </div>
);

export default PriceAccessNote;
